import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconEdit: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4 16.6671V20H7.33287L17.1626 10.1703L13.8297 6.83738L4 16.6671ZM19.74 7.59283C20.0867 7.24622 20.0867 6.68629 19.74 6.33967L17.6603 4.25996C17.3137 3.91335 16.7538 3.91335 16.4072 4.25996L14.7807 5.8864L18.1136 9.21927L19.74 7.59283Z',
    })
  )
}
